module.exports = __webpack_public_path__ + "assets/retina_ChordMidpointDetailed.cf25b6b2b84aa32b99afaebf986f2bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ChordMidpointDetailed.png
// module id = 634
// module chunks = 0